/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { success, error } from '@/libs/notification';
import router from '@/router';
import {
  SubCategoriesState,
  SubCategoriesDataState,
  SubCategoriesSubmitDataState,
  SubCategoriesSubmitResponseState,
  SubCategoryReplaceData
} from '@/types/master/subCategory';

import { ElLoading } from 'element-plus';
import { handleAuthorizationError } from '@/libs/apiErrorHandler';
import { getAccessToken } from '@/libs/firebaseAuth';
import { getBaseUrl } from '@/libs/env';

export default {
  namespaced: true,
  state: {
    listData: [],
    replaceData: null
  },
  mutations: {
    setSubCategories(
      state: SubCategoriesState,
      payload: SubCategoriesDataState[]
    ) {
      state.listData = payload;
    },
    setSubmitResponseData(
      state: SubCategoriesState,
      payload: SubCategoriesSubmitResponseState
    ) {
      state.submitResponseData = payload;
    },
    setReplace(state: SubCategoriesState, payload: SubCategoryReplaceData) {
      state.replaceData = payload;
    }
  },
  actions: {
    async fetch(context: any) {
      await axios
        .get(getBaseUrl() + '/master/subcategories', {
          headers: { auth: await getAccessToken() }
        })
        .then((response) => {
          context.commit('setSubCategories', response.data);
          const replaceData: SubCategoryReplaceData = {};
          response.data.forEach((data: SubCategoriesDataState) => {
            replaceData[data.id] = data.name;
          });
          context.commit('setReplace', replaceData);
        })
        .catch(async (e) => {
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status < 500) {
            error(e.response.status);

            router.push('/top');
          } else {
            router.push('/error/server');
          }
        });
    },
    async submit(context: any, payload: SubCategoriesSubmitDataState) {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      await axios
        .post(getBaseUrl() + '/master/subcategories', payload, {
          headers: { auth: await getAccessToken() }
        })
        .then((response) => {
          context.commit('setSubmitResponseData', response.data);
          success('Success', '分類登録に成功しました。');
          router.push('/master/subCategory');
        })
        .catch(async (e) => {
          loadingInstance.close();
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status < 500) {
            error(e.response.status);
          } else {
            router.push('/error/server');
          }
        });
    }
  }
};
